webpackJsonp([150],{

/***/ 1295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingCourseTable_vue__ = __webpack_require__(3053);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d0a626_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingCourseTable_vue__ = __webpack_require__(5660);
function injectStyle (ssrContext) {
  __webpack_require__(5656)
  __webpack_require__(5658)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52d0a626"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingCourseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d0a626_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingCourseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSE_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["k"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* harmony export (immutable) */ __webpack_exports__["i"] = getFileExtension;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseFileTypeByFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);





var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  INTERN_SCOPE_ALL: 1, // 全部实习生
  INTERN_SCOPE_SPECIFIC: 2, // 指定实习生

  KNOWLEDGE_STATUS_ACTIVE: 2
};

var COURSE_FILE_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
  PPT: 'ppt',
  WORD: 'word',
  EXCEL: 'excel'
};

var opts = {
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  InternScopeMaps: [{ value: consts.INTERN_SCOPE_ALL, label: '全部' }, { value: consts.INTERN_SCOPE_SPECIFIC, label: '指定' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineInternTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banInternTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeInternTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  label: '图片'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 0,
  maxSizeMB: 1024,
  label: '视频'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PDF, {
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PDF'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PPT, {
  accept: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  extensions: ['ppt', 'pptx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PPT'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.WORD, {
  accept: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  extensions: ['doc', 'docx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Word'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.EXCEL, {
  accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  extensions: ['xls', 'xlsx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Excel'
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseFileTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0) {
    return COURSE_FILE_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0) {
    return COURSE_FILE_TYPES.VIDEO;
  }
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_FILE_TYPES).some(function (key) {
    return COURSE_FILE_TYPES[key] === type;
  })) {
    return type;
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).find(function (fileType) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    return config.accept.includes(type) || config.extensions.includes(ext);
  }) || '';
}

function getCourseUploadConfig(fileType) {
  if (fileType && COURSE_UPLOAD_TYPE_CONFIGS[fileType]) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    var maxSizeLabel = config.maxSizeMB >= 1024 ? (config.maxSizeMB / 1024).toFixed(config.maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : config.maxSizeMB + 'MB';
    var maxFilesLabel = config.maxFiles > 0 ? '\u6700\u591A ' + config.maxFiles + ' \u4E2A' : '可上传多个';

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, {
      tip: '\u652F\u6301\u4E0A\u4F20' + config.label + '\uFF0C' + maxFilesLabel + '\uFF0C\u5355\u4E2A\u6700\u5927 ' + maxSizeLabel
    });
  }

  var configs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
    return COURSE_UPLOAD_TYPE_CONFIGS[type];
  });
  return {
    accept: configs.reduce(function (result, item) {
      return result.concat(item.accept);
    }, []),
    extensions: configs.reduce(function (result, item) {
      return result.concat(item.extensions);
    }, []),
    maxFiles: 0,
    maxSizeMB: Math.max.apply(null, configs.map(function (item) {
      return item.maxSizeMB;
    })),
    tip: '支持图片、视频、PDF、PPT、Word、Excel，可上传多个文件，单个文件大小按类型限制'
  };
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var fileType = getCourseFileTypeByFile(file);
  if (!fileType) {
    return {
      valid: false,
      fileType: fileType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(fileType);
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  var currentTypeCount = Array.isArray(currentFiles) ? currentFiles.filter(function (item) {
    return getCourseFileTypeByFile(item) === fileType;
  }).length : 0;
  if (config.maxFiles > 0 && currentTypeCount >= config.maxFiles) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  return {
    valid: true,
    fileType: fileType,
    message: '',
    replaceAll: false
  };
}

/***/ }),

/***/ 3053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_intern_constants__ = __webpack_require__(1669);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PREVIEW_FILE_TYPES = ['img', 'video', 'pdf'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfTrainingCourseTable',
  data: function data() {
    return {
      loading: false,
      loadFailed: false,
      courses: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      expandedCourses: {},
      previewVisible: false,
      previewFile: null
    };
  },

  computed: {
    summaryText: function summaryText() {
      if (this.total === this.courses.length) {
        return '\u5171 ' + this.total + ' \u672C\u624B\u518C \xB7 \u5171 ' + this.fileCount + ' \u4E2A\u6587\u4EF6';
      }
      return '\u5171 ' + this.total + ' \u672C\u624B\u518C \xB7 \u672C\u9875 ' + this.fileCount + ' \u4E2A\u6587\u4EF6';
    },
    fileCount: function fileCount() {
      var _this = this;

      return this.courses.reduce(function (count, course) {
        return count + _this.courseFiles(course).length;
      }, 0);
    },
    previewType: function previewType() {
      var type = Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(this.previewFile);
      return type === 'img' ? 'image' : type;
    }
  },
  created: function created() {
    this.fetchCourses();
  },

  methods: {
    fetchCourses: function fetchCourses() {
      var _this2 = this;

      this.loading = true;
      this.loadFailed = false;
      return request.common('getSelfTrainingCourses', {
        current_page: this.currentPage,
        per_page: this.pageSize
      }).then(function (res) {
        var data = res && res.data ? res.data : {};
        _this2.courses = Array.isArray(data.data) ? data.data : [];
        _this2.total = Number(data.total) || 0;
        _this2.currentPage = Number(data.current_page) || _this2.currentPage;
        _this2.pageSize = Number(data.per_page) || _this2.pageSize;
      }).catch(function () {
        _this2.loadFailed = true;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
      this.courses = [];
      this.expandedCourses = {};
      return this.fetchCourses();
    },
    courseFiles: function courseFiles(course) {
      return course && Array.isArray(course.course_json) ? course.course_json.filter(function (file) {
        return file && (typeof file === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(file)) === 'object';
      }) : [];
    },
    publisherName: function publisherName(course) {
      var firstFile = this.courseFiles(course)[0] || {};
      return course.user_name || firstFile.submit_admin_name || '—';
    },
    formatFileSize: function formatFileSize(size) {
      var bytes = Number(size);
      if (!bytes || bytes < 0) return '—';
      if (bytes < 1024) return bytes + 'B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + 'KB';
      return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
    },
    getFileIcon: function getFileIcon(file) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file);
      var icons = {
        img: 'el-icon-picture-outline',
        video: 'el-icon-video-camera',
        pdf: 'el-icon-document',
        ppt: 'el-icon-document',
        word: 'el-icon-document',
        excel: 'el-icon-document'
      };
      return icons[type] || 'el-icon-document';
    },
    fileTypeClass: function fileTypeClass(file) {
      return 'is-' + (Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file) || 'file');
    },
    isPreviewable: function isPreviewable(file) {
      return !!(file && file.url && PREVIEW_FILE_TYPES.includes(Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file)));
    },
    isExpanded: function isExpanded(courseId) {
      return !!this.expandedCourses[courseId];
    },
    toggleCourse: function toggleCourse(courseId) {
      this.$set(this.expandedCourses, courseId, !this.isExpanded(courseId));
    },
    openPreview: function openPreview(file) {
      if (!this.isPreviewable(file)) return;
      this.previewFile = file;
      this.previewVisible = true;
    },
    downloadFile: function downloadFile(file) {
      if (!file || !file.url) return;
      if (!this.isDownloadableUrl(file.url)) {
        this.$message.error((file.name || '文件') + '\u4E0B\u8F7D\u5730\u5740\u65E0\u6548');
        return;
      }
      window.open(file.url, '_blank', 'noopener');
    },
    isDownloadableUrl: function isDownloadableUrl(url) {
      try {
        var link = document.createElement('a');
        link.href = url;
        return ['http:', 'https:'].includes(link.protocol);
      } catch (error) {
        return false;
      }
    },
    downloadAll: function downloadAll(course) {
      var _this3 = this;

      this.courseFiles(course).forEach(function (file) {
        return _this3.downloadFile(file);
      });
    }
  }
});

/***/ }),

/***/ 5656:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c028b7a2", content, true, {});

/***/ }),

/***/ 5657:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".course-card[data-v-52d0a626]{border-radius:10px}.course-card ::v-deep .el-card__header[data-v-52d0a626]{padding:16px 20px}.course-card ::v-deep .el-card__body[data-v-52d0a626]{padding:0 20px}.course-card__header[data-v-52d0a626],.course-file[data-v-52d0a626],.course-file__actions[data-v-52d0a626],.course-file__name-wrap[data-v-52d0a626],.course-item[data-v-52d0a626],.course-item__actions[data-v-52d0a626],.course-item__main[data-v-52d0a626],.course-item__title-row[data-v-52d0a626]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.course-card__header[data-v-52d0a626],.course-item[data-v-52d0a626]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.course-card__title[data-v-52d0a626]{color:#303133;font-size:15px;font-weight:600}.course-card__title i[data-v-52d0a626]{margin-right:8px;color:#409eff}.course-card__summary[data-v-52d0a626],.course-file__date[data-v-52d0a626],.course-file__size[data-v-52d0a626],.course-item__description[data-v-52d0a626]{color:#909399;font-size:12px}.course-item[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:14px 20px;padding:16px 0;border-bottom:1px solid #f0f2f5}.course-item[data-v-52d0a626]:last-child{border-bottom:0}.course-item__main[data-v-52d0a626]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:220px;gap:14px}.course-item__icon[data-v-52d0a626]{display:-webkit-box;display:-ms-flexbox;display:flex;width:38px;height:38px;-webkit-box-flex:0;-ms-flex:0 0 38px;flex:0 0 38px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:8px;background:#f2f7ff;color:#409eff;font-size:18px}.course-item__icon.is-folder[data-v-52d0a626]{background:#eef5ff;color:#409eff}.course-item__content[data-v-52d0a626]{min-width:0}.course-item__title-row[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.course-item__title[data-v-52d0a626]{overflow:hidden;color:#303133;font-size:14px;font-weight:600;text-overflow:ellipsis;white-space:nowrap}.course-item__count[data-v-52d0a626]{padding:3px 6px;border-radius:3px;background:#eff6ff;color:#409eff;font-size:11px}.course-item__description[data-v-52d0a626]{margin-top:5px}.course-file__actions[data-v-52d0a626],.course-item__actions[data-v-52d0a626]{-ms-flex-negative:0;flex-shrink:0;gap:8px}.course-file__actions .el-button+.el-button[data-v-52d0a626],.course-item__actions .el-button+.el-button[data-v-52d0a626]{margin-left:0}.course-file-list[data-v-52d0a626]{display:grid;width:100%;gap:6px;padding-left:52px}.course-file[data-v-52d0a626]{min-height:40px;gap:16px;padding:5px 10px;border-radius:6px;background:#f7f8fa}.course-file__name-wrap[data-v-52d0a626]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:100px;gap:8px}.course-file__icon[data-v-52d0a626]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;color:#409eff}.course-file__icon.is-excel[data-v-52d0a626],.course-file__icon.is-img[data-v-52d0a626],.course-item__icon.is-excel[data-v-52d0a626],.course-item__icon.is-img[data-v-52d0a626]{color:#20b26b}.course-file__icon.is-video[data-v-52d0a626],.course-item__icon.is-video[data-v-52d0a626]{color:#8b5cf6}.course-file__icon.is-pdf[data-v-52d0a626],.course-item__icon.is-pdf[data-v-52d0a626]{color:#f56c6c}.course-file__name[data-v-52d0a626]{overflow:hidden;color:#303133;font-size:13px;text-overflow:ellipsis;white-space:nowrap}.course-file__date[data-v-52d0a626]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.course-pagination[data-v-52d0a626]{padding:18px 0;text-align:right}.manual-empty[data-v-52d0a626]{padding:36px 0;color:#909399;text-align:center}.manual-empty i[data-v-52d0a626]{font-size:36px;color:#c0c4cc}.course-preview__pdf[data-v-52d0a626],.course-preview__video[data-v-52d0a626]{display:block;width:100%;height:72vh;border:0}.course-preview__video[data-v-52d0a626]{background:#111}.course-preview__image[data-v-52d0a626]{display:block;width:100%;height:72vh}@media (max-width:768px){.course-item__main[data-v-52d0a626]{min-width:100%}.course-item__actions[data-v-52d0a626]{padding-left:52px}.course-file-list[data-v-52d0a626]{padding-left:0}.course-file[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 12px}.course-file__name-wrap[data-v-52d0a626]{-ms-flex-preferred-size:100%;flex-basis:100%}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/course/SelfTrainingCourseTable.vue"],"names":[],"mappings":"AACA,8BAA8B,kBAAkB,CAC/C,AACD,wDAAwD,iBAAiB,CACxE,AACD,sDAAsD,cAAc,CACnE,AACD,sSAAsS,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,kBAAkB,CAC3Z,AACD,oEAAoE,yBAAyB,sBAAsB,6BAA6B,CAC/I,AACD,qCAAqC,cAAc,eAAe,eAAe,CAChF,AACD,uCAAuC,iBAAiB,aAAa,CACpE,AACD,0JAA0J,cAAc,cAAc,CACrL,AACD,8BAA8B,mBAAmB,eAAe,cAAc,eAAe,+BAA+B,CAC3H,AACD,yCAAyC,eAAe,CACvD,AACD,oCAAoC,mBAAmB,WAAW,OAAO,gBAAgB,QAAQ,CAChG,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,WAAW,YAAY,mBAAmB,kBAAkB,cAAc,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,kBAAkB,mBAAmB,cAAc,cAAc,CACzW,AACD,8CAA8C,mBAAmB,aAAa,CAC7E,AACD,uCAAuC,WAAW,CACjD,AACD,yCAAyC,mBAAmB,eAAe,OAAO,CACjF,AACD,qCAAqC,gBAAgB,cAAc,eAAe,gBAAgB,uBAAuB,kBAAkB,CAC1I,AACD,qCAAqC,gBAAgB,kBAAkB,mBAAmB,cAAc,cAAc,CACrH,AACD,2CAA2C,cAAc,CACxD,AACD,8EAA8E,oBAAoB,cAAc,OAAO,CACtH,AACD,0HAA0H,aAAa,CACtI,AACD,mCAAmC,aAAa,WAAW,QAAQ,iBAAiB,CACnF,AACD,8BAA8B,gBAAgB,SAAS,iBAAiB,kBAAkB,kBAAkB,CAC3G,AACD,yCAAyC,mBAAmB,WAAW,OAAO,gBAAgB,OAAO,CACpG,AACD,oCAAoC,mBAAmB,kBAAkB,cAAc,aAAa,CACnG,AACD,gLAAgL,aAAa,CAC5L,AACD,0FAA0F,aAAa,CACtG,AACD,sFAAsF,aAAa,CAClG,AACD,oCAAoC,gBAAgB,cAAc,eAAe,uBAAuB,kBAAkB,CACzH,AACD,oCAAoC,mBAAmB,kBAAkB,aAAa,CACrF,AACD,oCAAoC,eAAe,gBAAgB,CAClE,AACD,+BAA+B,eAAe,cAAc,iBAAiB,CAC5E,AACD,iCAAiC,eAAe,aAAa,CAC5D,AACD,8EAA8E,cAAc,WAAW,YAAY,QAAQ,CAC1H,AACD,wCAAwC,eAAe,CACtD,AACD,wCAAwC,cAAc,WAAW,WAAW,CAC3E,AACD,yBACA,oCAAoC,cAAc,CACjD,AACD,uCAAuC,iBAAiB,CACvD,AACD,mCAAmC,cAAc,CAChD,AACD,8BAA8B,mBAAmB,eAAe,YAAY,CAC3E,AACD,yCAAyC,6BAA6B,eAAe,CACpF,CACA","file":"SelfTrainingCourseTable.vue","sourcesContent":["\n.course-card[data-v-52d0a626]{border-radius:10px\n}\n.course-card ::v-deep .el-card__header[data-v-52d0a626]{padding:16px 20px\n}\n.course-card ::v-deep .el-card__body[data-v-52d0a626]{padding:0 20px\n}\n.course-card__header[data-v-52d0a626],.course-item[data-v-52d0a626],.course-item__main[data-v-52d0a626],.course-item__actions[data-v-52d0a626],.course-item__title-row[data-v-52d0a626],.course-file[data-v-52d0a626],.course-file__name-wrap[data-v-52d0a626],.course-file__actions[data-v-52d0a626]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.course-card__header[data-v-52d0a626],.course-item[data-v-52d0a626]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.course-card__title[data-v-52d0a626]{color:#303133;font-size:15px;font-weight:600\n}\n.course-card__title i[data-v-52d0a626]{margin-right:8px;color:#409eff\n}\n.course-card__summary[data-v-52d0a626],.course-item__description[data-v-52d0a626],.course-file__size[data-v-52d0a626],.course-file__date[data-v-52d0a626]{color:#909399;font-size:12px\n}\n.course-item[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:14px 20px;padding:16px 0;border-bottom:1px solid #f0f2f5\n}\n.course-item[data-v-52d0a626]:last-child{border-bottom:0\n}\n.course-item__main[data-v-52d0a626]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:220px;gap:14px\n}\n.course-item__icon[data-v-52d0a626]{display:-webkit-box;display:-ms-flexbox;display:flex;width:38px;height:38px;-webkit-box-flex:0;-ms-flex:0 0 38px;flex:0 0 38px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:8px;background:#f2f7ff;color:#409eff;font-size:18px\n}\n.course-item__icon.is-folder[data-v-52d0a626]{background:#eef5ff;color:#409eff\n}\n.course-item__content[data-v-52d0a626]{min-width:0\n}\n.course-item__title-row[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px\n}\n.course-item__title[data-v-52d0a626]{overflow:hidden;color:#303133;font-size:14px;font-weight:600;text-overflow:ellipsis;white-space:nowrap\n}\n.course-item__count[data-v-52d0a626]{padding:3px 6px;border-radius:3px;background:#eff6ff;color:#409eff;font-size:11px\n}\n.course-item__description[data-v-52d0a626]{margin-top:5px\n}\n.course-item__actions[data-v-52d0a626],.course-file__actions[data-v-52d0a626]{-ms-flex-negative:0;flex-shrink:0;gap:8px\n}\n.course-item__actions .el-button+.el-button[data-v-52d0a626],.course-file__actions .el-button+.el-button[data-v-52d0a626]{margin-left:0\n}\n.course-file-list[data-v-52d0a626]{display:grid;width:100%;gap:6px;padding-left:52px\n}\n.course-file[data-v-52d0a626]{min-height:40px;gap:16px;padding:5px 10px;border-radius:6px;background:#f7f8fa\n}\n.course-file__name-wrap[data-v-52d0a626]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:100px;gap:8px\n}\n.course-file__icon[data-v-52d0a626]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;color:#409eff\n}\n.course-item__icon.is-img[data-v-52d0a626],.course-item__icon.is-excel[data-v-52d0a626],.course-file__icon.is-img[data-v-52d0a626],.course-file__icon.is-excel[data-v-52d0a626]{color:#20b26b\n}\n.course-item__icon.is-video[data-v-52d0a626],.course-file__icon.is-video[data-v-52d0a626]{color:#8b5cf6\n}\n.course-item__icon.is-pdf[data-v-52d0a626],.course-file__icon.is-pdf[data-v-52d0a626]{color:#f56c6c\n}\n.course-file__name[data-v-52d0a626]{overflow:hidden;color:#303133;font-size:13px;text-overflow:ellipsis;white-space:nowrap\n}\n.course-file__date[data-v-52d0a626]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto\n}\n.course-pagination[data-v-52d0a626]{padding:18px 0;text-align:right\n}\n.manual-empty[data-v-52d0a626]{padding:36px 0;color:#909399;text-align:center\n}\n.manual-empty i[data-v-52d0a626]{font-size:36px;color:#c0c4cc\n}\n.course-preview__pdf[data-v-52d0a626],.course-preview__video[data-v-52d0a626]{display:block;width:100%;height:72vh;border:0\n}\n.course-preview__video[data-v-52d0a626]{background:#111\n}\n.course-preview__image[data-v-52d0a626]{display:block;width:100%;height:72vh\n}\n@media (max-width: 768px){\n.course-item__main[data-v-52d0a626]{min-width:100%\n}\n.course-item__actions[data-v-52d0a626]{padding-left:52px\n}\n.course-file-list[data-v-52d0a626]{padding-left:0\n}\n.course-file[data-v-52d0a626]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 12px\n}\n.course-file__name-wrap[data-v-52d0a626]{-ms-flex-preferred-size:100%;flex-basis:100%\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5658:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b78b1e0e", content, true, {});

/***/ }),

/***/ 5659:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".self-training-preview-dialog .el-dialog__body{padding:12px 20px 20px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/course/SelfTrainingCourseTable.vue"],"names":[],"mappings":"AACA,+CAA+C,sBAAsB,CACpE","file":"SelfTrainingCourseTable.vue","sourcesContent":["\n.self-training-preview-dialog .el-dialog__body{padding:12px 20px 20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"self-training-course-page"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("培训手册")])],1)],1),_vm._v(" "),_c('el-card',{staticClass:"course-card",attrs:{"shadow":"never"}},[_c('div',{staticClass:"course-card__header",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"course-card__title"},[_c('i',{staticClass:"el-icon-reading"}),_vm._v("培训手册")]),_vm._v(" "),_c('span',{staticClass:"course-card__summary"},[_vm._v(_vm._s(_vm.summaryText))])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"course-list"},[_vm._l((_vm.courses),function(course){return _c('article',{key:course.id,staticClass:"course-item"},[_c('div',{staticClass:"course-item__main"},[_c('div',{class:['course-item__icon', _vm.courseFiles(course).length > 1 ? 'is-folder' : _vm.fileTypeClass(_vm.courseFiles(course)[0])]},[_c('i',{class:_vm.courseFiles(course).length > 1 ? 'el-icon-folder-opened' : _vm.getFileIcon(_vm.courseFiles(course)[0])})]),_vm._v(" "),_c('div',{staticClass:"course-item__content"},[_c('div',{staticClass:"course-item__title-row"},[_c('span',{staticClass:"course-item__title"},[_vm._v(_vm._s(course.title))]),_vm._v(" "),(_vm.courseFiles(course).length > 1)?_c('span',{staticClass:"course-item__count"},[_vm._v("共 "+_vm._s(_vm.courseFiles(course).length)+" 个文件")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"course-item__description"},[(_vm.courseFiles(course).length > 1)?[_vm._v("\n                含 "+_vm._s(_vm.courseFiles(course).length)+" 个文件\n              ")]:[_vm._v("\n                "+_vm._s((_vm.courseFiles(course)[0] || {}).name || '暂无文件')+"\n              ")],_vm._v("\n              · 发布人 "+_vm._s(_vm.publisherName(course))+" · "+_vm._s(course.created_at)+"\n            ")],2)])]),_vm._v(" "),_c('div',{staticClass:"course-item__actions"},[(_vm.courseFiles(course).length > 1)?[_c('el-button',{staticClass:"course-toggle",attrs:{"size":"mini","plain":"","type":"primary"},on:{"click":function($event){return _vm.toggleCourse(course.id)}}},[_c('i',{class:_vm.isExpanded(course.id) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'}),_vm._v("\n              "+_vm._s(_vm.isExpanded(course.id) ? '收起文件' : '展开文件')+"\n            ")]),_vm._v(" "),_c('el-button',{staticClass:"download-button",attrs:{"size":"mini","plain":""},on:{"click":function($event){return _vm.downloadAll(course)}}},[_c('i',{staticClass:"el-icon-download"}),_vm._v("下载全部\n            ")])]:(_vm.courseFiles(course).length)?[(_vm.isPreviewable((_vm.courseFiles(course)[0] || {})))?_c('el-button',{staticClass:"preview-button",attrs:{"size":"mini","plain":"","type":"primary"},on:{"click":function($event){_vm.openPreview(_vm.courseFiles(course)[0])}}},[_c('i',{staticClass:"el-icon-view"}),_vm._v("预览\n            ")]):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"download-button",attrs:{"size":"mini","plain":"","disabled":!_vm.courseFiles(course)[0].url},on:{"click":function($event){_vm.downloadFile(_vm.courseFiles(course)[0])}}},[_c('i',{staticClass:"el-icon-download"}),_vm._v("下载\n            ")])]:_vm._e()],2),_vm._v(" "),(_vm.courseFiles(course).length > 1 && _vm.isExpanded(course.id))?_c('div',{staticClass:"course-file-list"},_vm._l((_vm.courseFiles(course)),function(file,index){return _c('div',{key:file.uid || file.url || index,staticClass:"course-file"},[_c('div',{staticClass:"course-file__name-wrap"},[_c('i',{class:['course-file__icon', _vm.fileTypeClass(file), _vm.getFileIcon(file)]}),_vm._v(" "),_c('span',{staticClass:"course-file__name",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name || '未命名文件'))])]),_vm._v(" "),_c('span',{staticClass:"course-file__size"},[_vm._v(_vm._s(_vm.formatFileSize(file.size)))]),_vm._v(" "),_c('span',{staticClass:"course-file__date"},[_vm._v(_vm._s(file.submit_at || course.created_at))]),_vm._v(" "),_c('div',{staticClass:"course-file__actions"},[(_vm.isPreviewable(file))?_c('el-button',{staticClass:"preview-button",attrs:{"size":"mini","plain":"","type":"primary"},on:{"click":function($event){return _vm.openPreview(file)}}},[_c('i',{staticClass:"el-icon-view"}),_vm._v("预览\n              ")]):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"download-button",attrs:{"size":"mini","plain":"","disabled":!file.url},on:{"click":function($event){return _vm.downloadFile(file)}}},[_c('i',{staticClass:"el-icon-download"}),_vm._v("下载\n              ")])],1)])}),0):_vm._e()])}),_vm._v(" "),(!_vm.loading && _vm.loadFailed)?_c('div',{staticClass:"manual-empty"},[_c('p',[_vm._v("培训手册加载失败")]),_vm._v(" "),_c('el-button',{staticClass:"manual-retry",attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.fetchCourses}},[_vm._v("重新加载\n        ")])],1):(!_vm.loading && !_vm.courses.length)?_c('div',{staticClass:"manual-empty"},[_c('i',{staticClass:"el-icon-reading"}),_vm._v(" "),_c('p',[_vm._v("暂无培训手册")])]):_vm._e()],2),_vm._v(" "),(_vm.total > _vm.pageSize)?_c('el-pagination',{staticClass:"course-pagination",attrs:{"background":"","layout":"prev, pager, next, total","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total,"disabled":_vm.loading},on:{"current-change":_vm.changePage}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.previewVisible,"title":_vm.previewFile ? _vm.previewFile.name : '培训文件预览',"width":"80%","top":"5vh","append-to-body":"","custom-class":"self-training-preview-dialog"},on:{"update:visible":function($event){_vm.previewVisible=$event},"close":function($event){_vm.previewFile = null}}},[(_vm.previewFile && _vm.previewType === 'pdf')?_c('iframe',{staticClass:"course-preview__pdf",attrs:{"src":_vm.previewFile.url,"title":_vm.previewFile.name}}):(_vm.previewFile && _vm.previewType === 'video')?_c('video',{staticClass:"course-preview__video",attrs:{"src":_vm.previewFile.url,"controls":"","autoplay":""}}):(_vm.previewFile && _vm.previewType === 'image')?_c('el-image',{staticClass:"course-preview__image",attrs:{"fit":"contain","src":_vm.previewFile.url,"preview-src-list":[_vm.previewFile.url]}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/self-training-course.d7e7f755ad394d55534a.js